import { FC } from "react";
import _ from "lodash";
import CustomPopup from "../../../custom-components/CustomPopup";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectRawSubscriptions } from "../../../slices/subscriptions-slice";
import SubscriptionStatusLabel from "../../resources/components/subscription-components/SubscriptionStatusLabel";
import { getNormalizedTimeAndDate } from "../../../tools/DatetimeTools";

interface SubscriptionsArchivePopupProps {
    isVisible: boolean;
    setIsVisible: (value: boolean) => void;
}

const SubscriptionsArchivePopup: FC<SubscriptionsArchivePopupProps> = (props) => {
    const subscriptions = useSelector(selectRawSubscriptions);
    const { t } = useTranslation();

    return (
        <CustomPopup
            isVisible={props.isVisible}
            setIsVisible={props.setIsVisible}
            wrapClassName="dmin2:min-w-[846px] di6:min-w-[866px] di6:max-w-[866px] ti6:min-w-[550px] ti6:max-w-[550px] ti7:min-w-[480px] ti7:max-w-[480px] tmax4:max-w-[360px]"
            title={t("subscription.subscribesArchive")}
            titleClassName="mb-8 dmax2:mb-6 mt-2 dmax2:mt-[10px]"
            childrenWrapperClassName="pr-5 dmax2:pr-3"
        >
            <div className="flex flex-col items-center max-h-[355px]">
                {subscriptions.length <= 0 ? (
                    <>
                        <span className="H24 dmax2:H20 text-textFaded text-center mb-6 tmax4:w-[320px]">
                            {t("userProfile.emptyWorks")}
                        </span>
                        <div
                            onClick={() => {
                                props.setIsVisible(false);
                            }}
                            className="button H16B dmax2:H14B text-textWhite w-fit h-[50px] dmax2:h-10 px-6 dmax2:px-4 transition duration-300"
                        >
                            {t("subscription.goToSubscription")}
                        </div>
                    </>
                ) : (
                    subscriptions.map((subscription, index) => (
                        <div
                            key={`subscription-${subscription.id}`}
                            className={`flex gap-7 items-center justify-between tmax3:items-start w-full py-5 ${
                                index + 1 < subscriptions.length ? "border-b border-b-[rgba(75,75,82,1)]" : ""
                            }`}
                        >
                            <div className="flex tmax5:flex-col gap-7 tmax4:gap-3 items-center tmax3:items-start">
                                <SubscriptionStatusLabel
                                    subscription={subscription}
                                    wrapClassName="flex-wrap ti6:max-w-[125px] di6:max-w-[125px] dmin2:max-w-[145px]"
                                />
                                <div className="flex tmax3:flex-col items-center tmax3:items-start gap-7 tmax3:gap-2">
                                    <div className="flex items-center">
                                        <span className="H20 dmax2:H14B text-textFaded mr-3">
                                            {t("subscription.activationDate")}
                                        </span>
                                        <span className="H20 dmax2:H14B text-textWhite">
                                            {getNormalizedTimeAndDate(subscription.activationTime)}
                                        </span>
                                    </div>
                                    <div className="flex items-center">
                                        <span className="H20 dmax2:H14B text-textFaded mr-3">
                                            {t("subscription.deactivationDate")}
                                        </span>
                                        <span className="H20 dmax2:H14B text-textWhite">
                                            {getNormalizedTimeAndDate(subscription.deactivationTime)}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <span className="H20 text-textFaded">
                                {subscription.price.amount} {t(`currencies.short.${subscription.price.currency}`)}
                            </span>
                        </div>
                    ))
                )}
            </div>
        </CustomPopup>
    );
};

export default SubscriptionsArchivePopup;
